(function () {
  function openMetalAccordion(event) {
    var trigger = event.target.closest(
      'a[href="#ProductAccordion-metal"], a[href*="#ProductAccordion-metal"], [data-cb-scroll-open="metal"], [data-cb-open-metal-details]'
    );

    if (!trigger) return;

    event.preventDefault();

    var section = trigger.closest('product-info') || document.querySelector('product-info');
    var metalAccordion = null;

    if (section) {
      metalAccordion =
        section.querySelector('[data-cb-accordion-key="metal"]') ||
        section.querySelector('[id^="ProductAccordion-metal"]');
    }

    if (!metalAccordion) {
      metalAccordion =
        document.querySelector('[data-cb-accordion-key="metal"]') ||
        document.querySelector('[id^="ProductAccordion-metal"]');
    }

    if (!metalAccordion) return;

    var details = metalAccordion.querySelector('details');

    if (details) {
      details.open = true;
    }

    window.setTimeout(function () {
      var header = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header');
      var headerHeight = header ? header.getBoundingClientRect().height : 0;
      var top = metalAccordion.getBoundingClientRect().top + window.scrollY - headerHeight - 16;

      window.scrollTo({
        top: top,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }, 80);
  }

  document.addEventListener('click', openMetalAccordion);
})();